/** Rappel interne gestionnaire — pas inséré dans le PDF du courrier. */

export const LPP_DECOMPTE_PIECES_JOINTES_TITLE =
  "Attention – Documents à joindre";

export const LPP_DECOMPTE_PIECES_JOINTES_INTRO =
  "Lors de l'envoi de ce courrier, pensez à joindre obligatoirement :";

export const LPP_DECOMPTE_PIECES_JOINTES_ITEMS = [
  "La réponse de la caisse téléversée (notamment la réponse concernant la prévoyance surobligatoire ou supplémentaire).",
  "La procuration du client.",
];
